import { icons } from '@lifebit-ai/lds'
import styled, { css } from 'styled-components'

const iconStyle = css`
  min-height: ${({ theme }) => theme.size.icon.small};
  min-width: ${({ theme }) => theme.size.icon.small};
  width: ${({ theme }) => theme.size.icon.small};
  height: ${({ theme }) => theme.size.icon.small};
`

export const ApprovedIcon = styled(icons.CheckCircleSmall)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.success.default};
  }
`

export const RejectedIcon = styled(icons.CrossInCircleSmall)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.danger.default};
  }
`

export const FailedIcon = styled(icons.ErrorSmall)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.danger.default};
  }
`

export const PendingIcon = styled(icons.ClockSmall)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.warning.default};
  }
`

export const IconContainer = styled.div`
  display: flex !important;
  align-items: center;
  gap: 4px;

  svg {
    height: 16px;
    width: 16px;
  }
`

export const ProcessingIcon = styled(icons.StaticLoaderV2)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.action.default};
  }
`

export const PreparingIcon = styled(icons.StaticLoaderV2)`
  ${iconStyle}

  path {
    fill: ${({ theme }) => theme.color.feedback.action.default};
  }
`
